import React, { useContext, useState } from "react";
import { Box, Text, Input } from "@chakra-ui/core";
import { ContextStore } from "context/ContextStore";

const FoodComments = () => {
  const { currentOrder, setCurrentOrder } = useContext(ContextStore);

  function handleComments(e) {
    setCurrentOrder({ ...currentOrder, comments: e.target.value });
  }

  return (
    <Box pt={currentOrder?.options ? "5" : "0"}>
      <Box bg="gray.50" w="full" mb="4" px="6" py="4">
        <Text fontSize="md" fontWeight="bold" textTransform="uppercase" color="gray.900" pb="1">
          Commentaire
          <Box as="span" textTransform="uppercase" fontSize="xs" fontWeight="medium" color="gray.600" pl="2">
            Optionnel
          </Box>
        </Text>
        <Text fontSize="sm" fontWeight="medium" color="gray.600">
          Laissez un commentaire pour le chef
        </Text>
      </Box>
      <Box px="6">
        <Input
          type="text"
          placeholder="Commentaire pour le chef (optionnel)"
          focusBorderColor="brand.500"
          value={currentOrder?.comments || ""}
          onChange={handleComments}
        />
        <Text fontSize="xs" mt="4" color="gray.600">
          Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique veuillez nous en
          aviser directement avant de passer votre commande.
        </Text>
      </Box>
    </Box>
  );
};

export default FoodComments;
